<template>
  <div>
    <!--  header-->
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="safety-certificate" />
            <span>{{ $t("message.logData.title1") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="user-add" />
            <span>{{ $t("message.userManagement.title2") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title" style="margin-bottom: 20px">{{ $t("message.userManagement.pageTitle") }}</div>

    <!-- 新增用户modal -->
    <a-modal :title="$t('message.userManagement.addUserTitle')"
      @cancel="searchLoading = false; disabledEmail = false; userDialogVisible = false" :visible="userDialogVisible"
      width="760px" :maskClosable="false" destroyOnClose>
      <template slot="footer">
        <a-button :size="$globalSize" @click="searchLoading = false; disabledEmail = false; userDialogVisible = false"
          destroyOnClose>
          {{ $t('message.commonUsage.cancel') }}
        </a-button>
        <a-button :size="$globalSize" type="primary" @click="handleAddUserOk" :loading="addConfirmLoading"
          :disabled="emailValid">
          {{ $t('message.commonUsage.save') }}
        </a-button>
      </template>
      <a-spin :spinning="searchLoading" :tip="emailValid ? $t('message.userManagement.addUserMsg6') : ''">
        <div>
          <a-form-model :model="userAddForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }" :rules="userAddRules"
            ref="userAddRuleForm">
            <a-form-model-item :label="$t('message.userManagement.addUserTitle9')" prop="email" :rules="[
              { required: true, message: $t('message.userManagement.addUserMsg2') },
              { type: 'email', message: $t('message.userManagement.addUserMsg5') }
            ]">
              <a-input :size="$globalSize" v-model="userAddForm.email" :disabled="disabledEmail"
                :placeholder="$t('message.userManagement.addUserTitle10')" @blur="checkEmailExists"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('message.userManagement.addUserTitle3')" prop="username">
              <a-input :size="$globalSize" v-model="userAddForm.username"
                :placeholder="$t('message.userManagement.addUserTitle4')"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('message.userManagement.addUserTitle5')" prop="password">
              <a-input :size="$globalSize" :placeholder="$t('message.userManagement.addUserTitle6')"
                v-model="userAddForm.password" style="width: 160px"></a-input>
              <a-radio-group :size="$globalSize" @change="changePasswordType" v-model="passwordType"
                style="margin-left: 30px">
                <a-radio :value="1">
                  {{ $t("message.userManagement.addUserTitle7") }}</a-radio>
                <a-radio :value="2">
                  {{ $t("message.userManagement.addUserTitle8") }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
            <a-form-model-item v-if="userAddForm.role_id != '1'" :label="$t('message.userManagement.addUserTitle11')"
              prop="role_id">
              <a-select :size="$globalSize" :placeholder="$t('message.userManagement.addUserTitle12')"
                v-model="userAddForm.role_id" :options="role_options">
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-spin>
    </a-modal>

    <!-- 重新写一个modal form   -->
    <a-modal :title="$t('message.userManagement.editUserTitle')" ref="" :maskClosable="false" :visible="dialogUpdUser"
      :cancelText="$t('message.userManagement.addUserTitle1')" :okText="$t('message.userManagement.addUserTitle2')"
      @cancel="dialogUpdUser = false" @ok="updUser" :confirmLoading="editConfirmLoading" width="900px" destroyOnClose>
      <a-form-model ref="updUserRuleForm" :model="updUserForm" :rules="updUserRules" :label-col="{ span: 4 }"
        :wrapper-col="{ span: 16 }">
        <a-form-model-item label="ID" prop="user_id">
          <a-input :size="$globalSize" allowClear v-model="updUserForm.user_id" disabled></a-input>
        </a-form-model-item>
        <a-form-model-item :label="$t('message.userManagement.tableTitle1')" prop="user_name">
          <a-input :size="$globalSize" allowClear v-model="updUserForm.user_name"></a-input>
        </a-form-model-item>

        <a-form-model-item :label="$t('message.userManagement.tableTitle3')" v-if="updUserForm.role_id != '1'"
          prop="email">
          <a-input :size="$globalSize" allowClear v-model="updUserForm.email" :disabled="isMicrosoft"></a-input>
        </a-form-model-item>
        <a-form-model-item v-if="updUserForm.role_id != '1'" :label="$t('message.userManagement.tableTitle2')"
          prop="role_id">
          <a-select :size="$globalSize" v-model="updUserForm.role_id" :options="role_options">
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--  content -->
    <!-- search card   -->
    <div class="search mb16">
      <a-card>
        <a-row :gutter="32">
          <a-col class="gutter-row" :span="6">
            <a-input :size="$globalSize" :placeholder="$t('message.userManagement.searchMsg1')"
              v-model="userIdSearchInput" allowClear>
              <div slot="addonBefore">
                {{ $t("message.userManagement.tableTitle") }}：
              </div>
            </a-input>
          </a-col>
          <a-col class="gutter-row" :span="8" style="line-height: 32px">
            {{ $t("message.userManagement.tableTitle2") }}：
            <a-select :size="$globalSize" style="width: 68%" :placeholder="$t('message.userManagement.addUserTitle12')"
              v-model="userRoleSearchInput" allowClear>
              <a-select-option v-for="role in role_options" :key="role.value">
                {{ role.label }}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col class="gutter-row" :span="6">
            <a-input :size="$globalSize" :placeholder="$t('message.userManagement.searchMsg2')"
              v-model="userEmailSearchInput" allowClear>
              <div slot="addonBefore">
                {{ $t("message.userManagement.searchTitle1") }}：
              </div>
            </a-input>
          </a-col>
          <a-col class="gutter-row" :span="4">
            <a-button :size="$globalSize" class="my-btn"  style="float: right;" type="primary" :disabled="userLoading"
              @click="onSearch">
              {{ $t("message.userManagement.searchBtn1") }}
            </a-button>
          </a-col>
        </a-row>
      </a-card>
    </div>
    <div class="flex justify-content-end">
      <a-button :size="$globalSize" type="primary" class="my-btn" icon="plus-circle"
        @click="addUser" :disabled="$store.getters.hasPermission($store.state.LIMIT_CONSTANTS.USER_LIMIT)">
        {{ $t("message.userManagement.addUserBttn") }}
      </a-button>
    </div>
    <!-- table card   -->
    <div class="content mt16">
      <a-card>
        <a-table :columns="fields" :data-source="filterUsers" :style="{
          marginTop: selectedRowKeys.length > 0 ? '95px' : '15px',
        }" rowKey="user_id" :loading="userLoading" :scroll="{ x: 1500 }" :pagination="false">
          <!--                ant-table-row ant-table-row-level-0-->
          <template slot="action" slot-scope="text, record, index">
            <div style="
                    display: flex;
                    justify-content: center;
                    grid-gap: 8px;
                    align-items: center;
                  ">
              <a-button type="primary" shape="circle" class="edit-btn-icon"
                @click="openUpdUserDialog(text, record, index)" />
              <a-button type="primary" shape="circle" class="delete-btn-icon" @click="deleteUser(record)" />
              <a-switch checked-children="" un-checked-children="" default-checked
                v-model="record.status == 1 ? true : false" @change="changEnable(record, index)" />
            </div>

          </template>
          <template slot="created_at" slot-scope="text, record">
            <span>{{ convertToDefaultTimezone(showTime(record.created_at)) }}</span>
          </template>

          <template slot="updated_at" slot-scope="text, record">
            <span>{{ convertToDefaultTimezone(showTime(record.updated_at)) }}</span>
          </template>
        </a-table>
        <my-pagination ref="myPaginationRef" @change="queryAllUser" :total="totalCount"
          style="padding-top: 20px"></my-pagination>

      </a-card>
    </div>
    <!-- 邮箱已存在，绑定角色 -->
    <a-modal :title="$t('message.userManagement.bindRole')" :visible="bindRoleModal" width="760px"
      @cancel="bindRoleModal = false" :maskClosable="false" destroyOnClose>
      <template slot="footer">
        <a-button :size="$globalSize" @click="bindRoleModal = false" destroyOnClose>
          {{ $t('message.commonUsage.cancel') }}
        </a-button>
        <a-button :size="$globalSize" type="primary" @click="bindRole" :loading="addConfirmLoading">
          {{ $t('message.commonUsage.save') }}
        </a-button>
      </template>
      <a-form-model :model="userAddForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }" :rules="userAddRules"
        ref="userBindFormRef">
        <a-form-model-item :label="$t('message.userManagement.addUserTitle9')" prop="email" :rules="[
          { required: true, message: $t('message.userManagement.addUserMsg2') },
          { type: 'email', message: $t('message.userManagement.addUserMsg5') }
        ]">
          <a-input :size="$globalSize" v-model="userAddForm.email"
            :placeholder="$t('message.userManagement.addUserTitle10')" disabled></a-input>
        </a-form-model-item>
        <a-form-model-item :label="$t('message.userManagement.addUserTitle11')" prop="role_id">
          <a-select :size="$globalSize" :placeholder="$t('message.userManagement.addUserTitle12')"
            v-model="userAddForm.role_id" :options="role_options">
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :title="$t('message.userManagement.emailExistsTitle')" :visible="emailExistModal" :maskClosable="false"
      @cancel="emailExistModal = false" destroyOnClose>
      <template slot="footer">
        <a-button :size="$globalSize" @click="emailExistModal = false" destroyOnClose>
          {{ $t('message.commonUsage.no') }}
        </a-button>
        <a-button :size="$globalSize" type="primary" @click="bindRoleModal = true">
          {{ $t('message.commonUsage.yes') }}
        </a-button>
      </template>
      <div>
        <!-- {{ $t('message.userManagement.emailExistsContent') }} -->
        {{ warningModalContent }}
      </div>
    </a-modal>
  </div>
</template>

<script>
import utils from "@/utils";
import userListService from "@/interface/pages/Authority/UserAuthority/userList";
import MyPagination from "@/components/MyPagination";
import { userTypeConstant } from "@/utils/constant";
export default {
  name: "UserMgt",
  components: {
    MyPagination,
  },
  mounted() {
    this.queryRoles();
  },
  computed: {
    isMicrosoft() {
      return this.userType === userTypeConstant.MICROSOFT;
    },
  },
  data() {
    let checkPwd = (rule, value, callback) => {
      if (!value) {
        callback("");
        return;
      }

      if (value.length < 8) {
        callback(this.$t('message.loginPage.passwordCharacters'));
      } else {
        var password = value.toUpperCase();
        var newpassword = value;

        // 数字,殊字符,大小写字母的匹配
        var boolean_num = false;
        var boolean_A = false;
        var boolean_a = false;
        var boolean_specialchar = false;
        for (var i = 0; i < newpassword.length; i++) {
          if (
            boolean_A == true &&
            boolean_a == true &&
            boolean_num == true &&
            boolean_specialchar == true
          )
            break;
          if (
            newpassword[i].charCodeAt() >= 65 &&
            newpassword[i].charCodeAt() <= 90
          ) {
            boolean_A = true;
            continue;
          }
          if (
            newpassword[i].charCodeAt() >= 48 &&
            newpassword[i].charCodeAt() <= 57
          ) {
            boolean_num = true;
            continue;
          }
          if (
            newpassword[i].charCodeAt() >= 97 &&
            newpassword[i].charCodeAt() < 122
          ) {
            boolean_a = true;
            continue;
          }
          if (
            (newpassword[i].charCodeAt() >= 33 &&
              newpassword[i].charCodeAt() <= 47) ||
            (newpassword[i].charCodeAt() >= 58 &&
              newpassword[i].charCodeAt() <= 64) ||
            (newpassword[i].charCodeAt() >= 91 &&
              newpassword[i].charCodeAt() &&
              newpassword[i].charCodeAt() <= 96) ||
            (newpassword[i].charCodeAt() >= 123 &&
              newpassword[i].charCodeAt() <= 127)
          ) {
            boolean_specialchar = true;
            continue;
          }
        }
        if (
          boolean_A == false ||
          boolean_a == false ||
          boolean_num == false ||
          boolean_specialchar == false
        ) {
          callback(this.$t('message.loginPage.passwordFormat'))
        } else {
          callback();
        }
      }
    };
    return {
      warningModalContent: '',
      currentUserId: {},
      emailExistModal: false,
      bindRoleModal: false,
      emailValid: true,
      disabledEmail: false,
      totalCount: 0,
      userType: userTypeConstant.MICROSOFT,
      routes: [
        {
          // path: 'first',
          breadcrumbName: "管理",
        },
        {
          // path: 'second',
          breadcrumbName: "用户管理",
        },
      ],

      //table
      selectedRowKeys: [],
      updUserModal: false,
      users: [],
      filterUsers: [],
      role_options: [],
      updUserForm: {
        id: "",
        user_id: "",
        user_name: "",
        password: "",
        password_again: "",
        role_id: "",
        email: "",
      },
      updUserFormCopy: {
        user_name: "",
        role_id: "",
        email: "",
      },
      updUserRules: {
        user_name: [
          {
            required: true,
            message: this.$t("message.userManagement.addUserTitle4"),
            trigger: "blur",
          },
        ],
        // password: [{ required: true, message: '密码不能为空！', trigger: 'blur' }, {validator: this.checkPwd}],
        // password_again: [{ required: true, message: '请再次输入密码！', trigger: 'blur' }, {validator: this.checkPwdAgain}],
        role_id: [
          {
            required: true,
            message: this.$t("message.userManagement.addUserTitle12"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("message.userManagement.searchMsg2"),
            trigger: "blur",
          },
          { type: "email", message: "请输入正确的邮箱格式!" },
        ],
      },
      userAddRules: {
        username: [
          {
            required: true,
            message: this.$t("message.userManagement.addUserTitle4"),
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: this.$t("message.userManagement.addUserMsg2"),
            trigger: "blur",
          },
        ],
        role_id: [
          {
            required: true,
            message: this.$t("message.userManagement.addUserMsg3"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("message.userManagement.addUserMsg4"),
            trigger: "chyange",
          },
          { validator: checkPwd, trigger: "change" },
        ],
      },
      fields: [
        {
          dataIndex: "user_id",
          title: () => this.$t("message.userManagement.tableTitle"),
          align: "left",
          width: 100,
          sorter: (a, b) => a.user_id - b.user_id,
        },
        {
          dataIndex: "user_name",
          title: () => this.$t("message.userManagement.tableTitle1"),
          align: "left",
          width: 100,
        },
        {
          dataIndex: "role_name",
          title: () => this.$t("message.userManagement.tableTitle2"),
          align: "left",
          width: 100,
        },
        {
          dataIndex: "email",
          title: () => this.$t("message.userManagement.tableTitle3"),
          align: "left",
          width: 100,
        },
        {
          dataIndex: "created_user_name",
          title: () => this.$t("message.userManagement.tableTitle4"),
          align: "left",
          width: 100,
        },
        {
          dataIndex: "created_at",
          title: () => this.$t("message.userManagement.tableTitle5"),
          width: 100,
          align: "left",
          sorter: (a, b) =>
            this.string2Date(a.created_at) - this.string2Date(b.created_at),
          scopedSlots: { customRender: "created_at" },
        },
        {
          dataIndex: "updated_user_name",
          title: () => this.$t("message.userManagement.tableTitle6"),
          align: "left",
          width: 100,
        },
        {
          dataIndex: "updated_at",
          title: () => this.$t("message.userManagement.tableTitle7"),
          width: 100,
          align: "left",
          sorter: (a, b) =>
            this.string2Date(a.updated_at) - this.string2Date(b.updated_at),
          scopedSlots: { customRender: "updated_at" },
        },
        {
          dataIndex: "action",
          title: () => this.$t("message.userManagement.tableAction"),
          width: 150,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],

      //rules
      password: "",
      password_again: "",
      old_password: "",

      old_password_help: "",
      old_password_validate_status: "",
      password_help: "",
      password_validate_status: "",
      password_again_help_: "",
      password_again_validate_status: "",

      //dialog
      dialogAddUser: false,
      dialogUpdUser: false,
      form: this.$form.createForm(this, "register"),

      //search header
      userIdSearchInput: "",
      userRoleSearchInput: '',
      userEmailSearchInput: "",
      userLoading: false,
      userDialogVisible: false,
      userSearchForm: {},
      userAddForm: {},
      passwordType: 2,
      user_info: null,
      searchLoading: false,
      confirmLoading: false,
      addConfirmLoading: false,
      editConfirmLoading: false,
    };
  },
  methods: {
    async checkEmailExists() {

      this.$refs.userAddRuleForm.validateField('email', async (err) => {
        if (err) return
        this.emailValid = true
        this.disabledEmail = true
        this.searchLoading = true
        try {
          const { data: res } = await userListService.checkUserExistence(this, { params: { email: this.userAddForm.email } });
          if (res.code === '200') {
            if (res.data) {
              this.currentUserId = res.data
              this.emailExistModal = true
              this.warningModalContent = res.message
            } else {
              this.emailValid = false
            }
          } else {
            this.$message.error(res.message)
          }
        } finally {
          this.disabledEmail = false
          this.searchLoading = false
        }
      })

    },

    bindRole() {
      this.$refs.userBindFormRef.validate((valid) => {
        if (valid) {
          this.addConfirmLoading = true;
          let body = {
            userId: this.currentUserId,
            roleId: this.userAddForm.role_id,
          };
          userListService
            .addExistingUser(this, { data: body })
            .then((response) => {
              let res = response.data;
              if (res.code == 200) {
                this.bindRoleModal = false;
                this.userDialogVisible = false;
                this.emailExistModal = false
                this.$store.dispatch('fetchButtonPermission')
                this.queryAllUser();
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((error) => {
              console.log("添加失败！");
            }).finally(() => {
              this.addConfirmLoading = false;
            });
          ;
        }
      });
    },

    deleteUser(record) {
      var that = this;
      this.$confirm({
        title: this.$t("message.commonUsage.delConfirmContent"),
        okText: this.$t("message.commonUsage.delete"),
        okType: "primary",
        cancelText: this.$t("message.commonUsage.cancel"),
        onOk() {
          return new Promise((resolve, reject) => {
            let body = {
              userId: record.user_id,
            };
            userListService
              .deleteUser(that, { data: body })
              .then((response) => {
                let res = response.data;
                if (res.code === '200') {
                  that.$message.success(res.message);
                  resolve();
                  that.$store.dispatch('fetchButtonPermission')
                  that.queryAllUser();
                } else {
                  that.$message.error(res.message);
                  reject();
                }
              })
              .catch((error) => {
                reject();
                console.log(error);
              });
          });
        },
        onCancel() {
          that.$message.warning(that.$t("message.txtManagement.txtMgtMsg4"));
        },
      });
    },
    changEnable(record, index) {
      var that = this;
      if (record.status == 1) {
        that.$confirm({
          title: this.$t("message.userManagement.popupTitle4"),
          okText: this.$t("message.userManagement.popupTitle6"),
          okType: "primary",
          cancelText: this.$t("message.commonUsage.cancel"),
          confirmLoading: this.confirmLoading,
          onOk() {
            return new Promise((resolve, reject) => {
              that.confirmLoading = true
              that.disableUser(record, "0", resolve);
            });
          },
          onCancel() {
            console.log("Cancel");
            //that.tag_level_data[index].status = 1;
          },
        });
      } else {
        that.$confirm({
          title: this.$t("message.userManagement.popupTitle1"),
          okText: this.$t("message.userManagement.popupTitle3"),
          okType: "primary",
          cancelText: this.$t("message.commonUsage.cancel"),
          confirmLoading: this.confirmLoading,
          onOk() {
            console.log(1)
            return new Promise((resolve, reject) => {
              that.confirmLoading = true
              that.disableUser(record, "1", resolve);
            })

          },
          onCancel() {
            console.log("Cancel");
            //that.tag_level_data[index].status = 0;
          },
        });
      }
    },
    disableUser(record, type, resolve = () => { }) {
      userListService
        .disableUser(this, {
          data: {
            userId: record.user_id,
            status: type,
          },
        })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            resolve()
            this.queryAllUser();
            this.$message.success(
              type == 1
                ? this.$t("message.userManagement.popupTitle7")
                : this.$t("message.userManagement.popupTitle8")
            );
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          console.log("添加失败！");
        }).finally(() => {
          console.log(12)
          this.confirmLoading = false
        });
    },
    changePasswordType(value) {
      let targetValue = value.target.value; // 1随机 2输入
      if (targetValue === 1) {
        this.userAddForm.password = this.makeid(4) + "Mcd22@";
        this.$refs.userAddRuleForm.clearValidate("password");
      } else if (targetValue === 2) {
        this.userAddForm.password = null;
        this.$refs.userAddRuleForm.validateField("password");
      }
      this.$forceUpdate();
    },
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },

    addUser() {
      this.userSearchForm = {};
      this.userAddForm = {};
      (this.passwordType = 2), (this.userDialogVisible = true);
    },
    handleAddUserOk() {
      this.$refs.userAddRuleForm.validate((valid) => {
        if (valid) {
          this.addConfirmLoading = true;
          let body = {
            userName: this.userAddForm.username,
            email: this.userAddForm.email,
            roleId: this.userAddForm.role_id,
            password: utils.encrypt(this.userAddForm.password),
            loginId: localStorage.getItem("userId"),
            // user_info: this.user_info
          };
          userListService
            .addUser(this, { data: body })
            .then((response) => {
              let res = response.data;
              if (res.code == 200) {
                this.userDialogVisible = false;
                this.$store.dispatch('fetchButtonPermission')
                this.queryAllUser();
                this.$message.success(
                  this.$t("message.userManagement.userMgtMsg1")
                );
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((error) => {
              console.log("添加失败！");
            }).finally(() => {
              this.addConfirmLoading = false;
            });
          ;
        }
      });
    },
    showTime(value) {
      if (typeof value == "undefined" || value == null || value == "") {
        return "-";
      }
      return utils.formatDate(new Date(value), "yyyy-MM-dd hh:mm:ss");
    },
    queryAllUser() {
      this.userLoading = true;

      const role_id = this.userRoleSearchInput || '';
      const email = this.userEmailSearchInput;
      const user_id = this.userIdSearchInput;

      let body = {
        'role_id': role_id,
        'email': email,
        'user_id': user_id,
        ...this.$refs.myPaginationRef.pagination
      };
      console.log(body)
      userListService
        .queryAllUser(this, { params: body })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            this.users = res.data;
            this.filterUsers = res.data;
            this.userLoading = false;
            this.totalCount = res.totalCount;
            this.$message.success(
              this.$t("message.userManagement.searchSucMsg")
            );
          } else {
            this.userLoading = false;
            if (res.code !== '400') {
              this.$message.error(res.message);
            }
          }
        })
        .catch((error) => {
          this.userLoading = false;
          console.log(this.$t("message.userManagement.searchFailMsg"));
        });
    },
    queryRoles() {
      let body = {
        userId: localStorage.getItem("userId"),
      };
      userListService
        .queryRoles(this, { params: body })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            this.role_options = res.data.map((item) => {
              return {
                ...item,
                value: item.role_id,
                label: item.role_name,
              };
            });
            // this.$message.success("查询成功！");
          } else {
            if (res.code !== '400') {
              this.$message.error(this.$t("message.userManagement.userMgtMsg2"));
            }
          }
        })
        .catch((error) => {
          console.log("查询失败！");
        });
    },
    updUser() {
      if (
        this.updUserFormCopy.user_name == this.updUserForm.user_name &&
        this.updUserFormCopy.role_id == this.updUserForm.role_id &&
        this.updUserFormCopy.email == this.updUserForm.email
      ) {
        this.$message.warning(
          this.$t("message.couponManagement.couponMgtMsg1")
        );
      } else {
        console.log(1);
        this.$refs.updUserRuleForm.validate((valid) => {
          if (valid) {
            this.editConfirmLoading = true;
            let body = {
              userName: this.updUserForm.user_name,
              email: this.updUserForm.email,
              roleId: this.updUserForm.role_id,
              loginId: localStorage.getItem("userId"),
              userId: this.updUserForm.user_id,
            };
            userListService
              .updUser(this, { data: body })
              .then((response) => {
                let res = response.data;
                if (res.code == 200) {
                  this.queryAllUser();
                  this.dialogUpdUser = false;
                  this.$message.success(
                    this.$t("message.userManagement.userMgtMsg3")
                  );
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch((error) => {
                console.log("更新失败！");
              }).finally(() => {
                this.editConfirmLoading = false;
              });

          }
        });
      }
    },
    checkPwd(rule, value, callback) {
      if (value.length < 8) {
        callback("密码不能少于8位");
      } else {
        var password = value.toUpperCase();
        var newpassword = value;
        // 数字,特殊字符,大小写字母的匹配
        var boolean_num = false;
        var boolean_A = false;
        var boolean_a = false;
        var boolean_specialchar = false;
        for (var i = 0; i < newpassword.length; i++) {
          if (
            boolean_A == true &&
            boolean_a == true &&
            boolean_num == true &&
            boolean_specialchar == true
          )
            break;
          if (
            newpassword[i].charCodeAt() >= 65 &&
            newpassword[i].charCodeAt() <= 90
          ) {
            boolean_A = true;
            continue;
          }
          if (
            newpassword[i].charCodeAt() >= 48 &&
            newpassword[i].charCodeAt() <= 57
          ) {
            boolean_num = true;
            continue;
          }
          if (
            newpassword[i].charCodeAt() >= 97 &&
            newpassword[i].charCodeAt() < 122
          ) {
            boolean_a = true;
            continue;
          }
          if (
            (newpassword[i].charCodeAt() >= 33 &&
              newpassword[i].charCodeAt() <= 47) ||
            (newpassword[i].charCodeAt() >= 58 &&
              newpassword[i].charCodeAt() <= 64) ||
            (newpassword[i].charCodeAt() >= 91 &&
              newpassword[i].charCodeAt() &&
              newpassword[i].charCodeAt() <= 96) ||
            (newpassword[i].charCodeAt() >= 123 &&
              newpassword[i].charCodeAt() <= 127)
          ) {
            boolean_specialchar = true;
            continue;
          }
        }
        if (
          boolean_A == false ||
          boolean_a == false ||
          boolean_num == false ||
          boolean_specialchar == false
        ) {
          callback("确认密码应该是数字、大小写字母、特殊字符的组合,请重新输入");
        } else {
          this.password = value;
          callback();
        }
      }
    },
    checkPwdAgain(rule, value, callback) {
      this.password_again = value;
      if (this.password != this.password_again) {
        callback("两次输入的密码不相同，请重新检查！");
      } else {
        callback();
      }
    },
    openUpdUserDialog(text, record) {
      this.dialogUpdUser = true;
      this.updUserForm.id = record.user_id;
      this.updUserForm.user_id = record.user_id;
      this.updUserForm.user_name = record.user_name;
      this.updUserForm.role_id = record.role_id;
      this.updUserForm.email = record.email;
      this.userType = record.type;

      this.updUserFormCopy.user_name = record.user_name;
      this.updUserFormCopy.role_id = record.role_id;
      this.updUserFormCopy.email = record.email;
    },
    openAddUserDialog() {
      this.dialogAddUser = true;
    },
    string2Date(str) {
      console.log(str);
      if (str == null || str == "-" || str == "") {
        str = "1021-09-08 09:58:05";
      }
      return new Date(str);
    },
    // delUser(text, record) {
    //   var that = this;
    //   this.$confirm({
    //     title: "确定删除这个用户吗?",
    //     content: "此操作将永久删除此用户",
    //     okText: "删除",
    //     okType: "primary",
    //     cancelText: "取消",
    //     onOk() {
    //       // let body = {
    //       //   record.id
    //       // };
    //       userListService
    //           .delUser(that,{ data: record.user_id })
    //           .then((response) => {
    //             let res = response.data;
    //             if (res.code == 200) {
    //               that.queryAllUser();
    //               that.dialogAddUser = false;
    //               that.$message.success("删除成功！");
    //             } else {
    //               that.$message.error("删除失败！");
    //             }
    //           })
    //           .catch((error) => {
    //             console.log("删除失败！");
    //           });
    //     },
    //     onCancel() {
    //       that.$message.warning("删除操作取消！");
    //     }
    //   });
    // },
    success() {
      this.$message.success("This is a success message");
    },
    onSearch() {
      var that = this;
      that.queryAllUser();
      // that.filterUsers = that.users.filter(function (data) {
      //   let flag = true;
      //   if (
      //     typeof that.userIdSearchInput != "undefined" &&
      //     that.userIdSearchInput.length > 0
      //   ) {
      //     flag =
      //       flag &&
      //       data.id
      //         .toString()
      //         .toLowerCase()
      //         .includes(that.userIdSearchInput.toString().toLowerCase());
      //   }
      //   if (
      //     typeof that.userRoleSearchInput != "undefined" &&
      //     that.userRoleSearchInput.length > 0
      //   ) {
      //     flag = flag && data.role_name == that.userRoleSearchInput;
      //   }
      //   if (
      //     typeof that.userEmailSearchInput != "undefined" &&
      //     that.userEmailSearchInput.length > 0
      //   ) {
      //     flag =
      //       flag &&
      //       data.email
      //         .toLowerCase()
      //         .includes(that.userEmailSearchInput.toString().toLowerCase());
      //   }
      //   return flag;
      // });
    },
    onSelectChange(selectedRowKeys, row) {
      // console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
      // console.log('selectedRowKeys changed: ', row);
    },
    cancelSelect() {
      this.selectedRowKeys = [];
    },
  },
};
</script>
